/**
 * Rows for the cross-reference profile comparison table (attributes × FI columns).
 * Field names align with BillerCrossReferenceDto from searchBillerCrossReference.
 */
export const BILLER_CROSS_REFERENCE_PROFILE_TABLE_ROWS = [
  {
    labelKey: "erps.billermanagement.label.internalBillerId",
    bmo: "bmoBillerId",
    bns: "bnsBillerId",
    cibc: "cibcBillerId",
  },
  {
    labelKey: "erps.billermanagement.crossreference.profile.externalBillerId",
    bmo: "externalBmoBillerId",
    bns: "externalBnsBillerId",
    cibc: "externalCibcBillerId",
  },
  {
    labelKey: "erps.billermanagement.label.billerName",
    bmo: "bmoBillerName",
    bns: "bnsBillerName",
    cibc: "cibcBillerName",
  },
  {
    labelKey: "erps.billermanagement.crossreference.profile.creditFiNumber",
    bmo: "bmoCreditorFiNumber",
    bns: "bnsCreditorFiNumber",
    cibc: "cibcCreditorFiNumber",
  },
  {
    labelKey: "erps.billermanagement.crossreference.profile.creditTransitNumber",
    bmo: "bmoCreditorTransitNumber",
    bns: "bnsCreditorTransitNumber",
    cibc: "cibcCreditorTransitNumber",
  },
  {
    labelKey: "erps.billermanagement.crossreference.profile.creditAccountNumber",
    bmo: "bmoCreditorAccountNumber",
    bns: "bnsCreditorAccountNumber",
    cibc: "cibcCreditorAccountNumber",
  },
  {
    labelKey: "erps.billermanagement.crossreference.profile.ccin",
    bmo: "bmoRecipientCcin",
    bns: "bnsRecipientCcin",
    cibc: "cibcRecipientCcin",
  },
];
